import { render, staticRenderFns } from "./phone-modify.vue?vue&type=template&id=fbea543e"
import script from "./phone-modify.vue?vue&type=script&lang=ts"
export * from "./phone-modify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports